(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["hatxa-mobile-purchase"] && !Shopify.designMode) return;
  try {
    
function setupHatxaMobilePurchase(){
  const bar=document.querySelector('[data-hatxa-mobile-buy]');
  if(!bar||bar.dataset.initialized)return;
  const main=document.querySelector('.product-information .buy-buttons-block');
  if(!main)return;
  bar.dataset.initialized='true';
  const select=bar.querySelector('[data-hatxa-mobile-select]');
  const price=bar.querySelector('[data-hatxa-mobile-price]');
  const updatePrice=()=>{if(select&&price)price.textContent=select.selectedOptions[0]?.dataset.price||price.textContent};
  select?.addEventListener('change',updatePrice);
  new IntersectionObserver(entries=>{
    const visible=!entries[0].isIntersecting&&window.scrollY>250;
    bar.hidden=!visible;
    if(visible&&select){
      const selected=document.querySelector('.product-information form input[name="id"]')?.value;
      if(selected&&Array.from(select.options).some(option=>option.value===selected)){select.value=selected;updatePrice()}
    }
  }).observe(main);
}
if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',setupHatxaMobilePurchase);else setupHatxaMobilePurchase();
document.addEventListener('shopify:section:load',setupHatxaMobilePurchase);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
